import { useEffect, useRef } from 'react';
import { useArticleDeletion } from '../model/use-article-deletion';
import { ArticleDeletionFeedback } from './ArticleDeletionFeedback';

/** Retains the immutable intent and actionable recovery without routine lifecycle notices. */
export function ArticleListDeletion({
  scope,
  id,
  canDelete,
  onClose,
}: {
  scope: string;
  id: string;
  title: string;
  canDelete: boolean;
  onClose: () => void;
}) {
  const deletion = useArticleDeletion({ scope, id, canDelete });
  const { beginDelete, deleted } = deletion;
  const started = useRef(false);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    void beginDelete();
  }, [beginDelete]);
  useEffect(() => {
    if (deleted) onClose();
  }, [deleted, onClose]);
  return (
    <ArticleDeletionFeedback
      deletion={{
        ...deletion,
        closeConfirmation: (open) => {
          deletion.closeConfirmation(open);
          if (!open && !deletion.pending) onClose();
        },
      }}
      canDelete={canDelete}
      onDismiss={onClose}
    />
  );
}
